// extracted by mini-css-extract-plugin
export default {"chipsGroup":"yBAsQzqyd9_services-landings"};